import React from 'react';
import { useDashboardFeatureFlags } from '@components';
import { Dropdown, Toasts, useModalContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import * as S from './ShopSwitch.styled';
import { ShopItem } from './components/ShopItem/ShopItem';
import { CreateNewSiteModalContainer } from './modules/CreateNewSiteModal';
export const ShopSwitch = ({ connectedShops }) => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { open, close } = useModalContext();
    const onCreateNewSiteClick = () => open(CreateNewSiteModalContainer, {
        onSuccess: (data) => {
            close();
            Toasts.notify(`${data.name} site created successfully.`, { type: 'success' });
            window.location.assign(`${data.internalBaseUri}${routing.home}`);
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, null,
            connectedShops?.map(({ id, internalBaseUri, baseUri, logoUri, name, primaryDomain }) => (React.createElement(ShopItem, { key: id, adminLink: `${internalBaseUri}${routing.home}`, shopLink: baseUri, label: name, labelDescription: primaryDomain, logoUrl: logoUri }))),
            dashboardFeatureFlags.createNewSite.enabled && (React.createElement(Dropdown.Item, { label: "Create a new site", onClick: onCreateNewSiteClick }))),
        React.createElement(Dropdown.Divider, null)));
};
